import React from "react";
import PropTypes from "prop-types";
import { Button, Dialog, useMediaQuery } from "@material-ui/core";
import { MOBILE_WIDTH } from "../sharedKernel/AppWrapper";
import { useTheme } from "@material-ui/styles";
import Text from "./Text";

export default function ResponsiveDialog({
  children,
  loading = false,
  displayCondition,
  fullScreenCondition,
  onClose,
  ...props
}) {
  const { breakpoints } = useTheme();
  const isScreenXs = useMediaQuery(breakpoints.down("xs"));
  let intViewportHeight = window.innerHeight;

  return (
    <ConditionalWrapper
      condition={displayCondition}
      wrapper={(children) => (
        <Dialog
          fullScreen={fullScreenCondition}
          style={{
            maxWidth: isScreenXs ? "100%" : MOBILE_WIDTH,
            maxHeight: isScreenXs || intViewportHeight < 800 ? "100%" : "85vh",
            margin: "auto",
            top: 0,
            left: 0,
          }}
          PaperProps={{
            square: true,
            elevation: 0,
            ...props.PaperProps,
          }}
          {...props}
        >
          {children}
        </Dialog>
      )}
    >
      {!loading && displayCondition && onClose && (
        <Button
          size="small"
          color="default"
          variant="outlined"
          aria-label="close"
          onClick={onClose}
          style={{
            position: "absolute",
            right: "1rem",
            top: "1rem",
          }}
        >
          <Text tId="CLOSE" />
        </Button>
      )}
      {children}
    </ConditionalWrapper>
  );
}

ResponsiveDialog.propTypes = {
  loading: PropTypes.bool,
  displayCondition: PropTypes.bool,
  fullScreenCondition: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

function ConditionalWrapper({ condition, wrapper, children }) {
  return <>{condition ? wrapper(children) : children}</>;
}
